import Vue from 'vue'
import Vuex from 'vuex'
import authfb from './authfb'
import order from './order'
import withdraw from './withdraw'
import deposit from './deposit'
import exchanged from './exchanged'
import buy_order from './buy_order'
import sell_order from './sell_order'

import { vuexfireMutations, firestoreAction } from 'vuexfire'

Vue.use(Vuex)


export default new Vuex.Store({

  modules:{
    authfb,
    order,
    withdraw,
    deposit,
    exchanged,
    buy_order,
    sell_order
  },
  state: {
    
      deposit: {
        btcDeposit: [{ id: 1, amount: '90000', hashId: '', date: '', status: 'completed' }],
        cfaDeposit: [{ id: 1, amount: '', payment: '', date: '', status: '' }]
      },
      withdraw: {
        btcWithdraw: [{ id: 1, amount: '200', wallet: 'justine', date: 'misk', status: 'completed' }],
        cfaWithdraw: [{ id: 1, amount: '', payment: '', account: '', date: '', status: '' }]
      }
    
  },

  mutations: {

    newBid(state, payload) {
      state.orders.buyOrders.push({
        bidTotal: payload.bidTotal,
        bidAmount: payload.bidAmount,
        bidPrice: payload.bidPrice,
        time: payload.time
      }),
        console.log(payload);

    },

    newAsk(state, payload) {
      state.orders.sellOrders.push({
        askTotal: payload.askTotal,
        askAmount: payload.askAmount,
        askPrice: payload.askPrice,
        time: payload.time
      });
      console.log(payload);

    },
    updateBalanceBid(state, payload) {
      state.cfaBalance -= payload.bidTotal
    },
    updateBalanceAsk(state, payload) {
      state.btcBalance -= payload.askAmount
      
    },
    ...vuexfireMutations,

  },
  actions: {
    bid: (context, payload) => {
      return context.dispatch('actionCfaBid',payload).then(() => {
        context.commit('newBid', payload);
      })
    }
    ,
    ask: (context, payload) => {
      return context.dispatch('actionBtcAsk',payload).then(() => {
        context.commit('newAsk', payload);
      })
    }
    ,
    actionCfaBid:(context,payload)=>{
      context.commit('updateBalanceBid', payload)
    },
    actionBtcAsk:(context,payload)=>{
      context.commit('updateBalanceAsk', payload)
      console.log(payload);
      
    },
  }




})